module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABHNCSVQICAgIfAhkiAAAAJBJREFUSInF0lEOgCAMA1DiyXY0bj5/TDQLjnXrtL8lfYQwxl9RVfl0V+9MJvbYFVsqEzWYbg9U0MWWRA/CaBhjoDBWQdNYBi1jCErDIigd89A2zEH7sA0KYQfhHhAYzuZJZzcmq4/UhjldDfUwOhrBaCiCldEMlkYrGIwyMAhlYQ4qb2UZC+1eJQ2z2x27oZyzMizb6ChclQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon-close-btn.png
// module id = WuyH
// module chunks = 1